import {mapActions, mapMutations , mapGetters} from "vuex";
import {Route} from "../registry/routes.js";
import Utils from "../components.utils.js";
export default {
    methods:{
      ...mapMutations("registry",["registerDamPlugin"]),
      ...mapMutations("pluginRepo",["setInstalledPluginsData"]),
      ...mapActions("pluginRepo", ["getInstalledPluginsFromServer"]),
      ...mapActions("startUpData",["getStartUpDataFromServer"]),
      ...mapActions("privileges", ["updateAllUserActionstoInMem"]),
      ...mapActions("users", ["getUserInfoFromServer"]),
      ...mapActions("websocket",["connectToWebSocket"]),
      connectToFusionWebSocket(startupDataInfo){
        let tempNotifierIP = Utils.getNotifierIp();
        if(startupDataInfo && Object.prototype.hasOwnProperty.call(startupDataInfo,"ACTIVE_NOTIFIER_IP")){
          tempNotifierIP = startupDataInfo.ACTIVE_NOTIFIER_IP;
        }
        let loggedInUserId = null;
        try{
           if(localStorage.getItem('fusion:u_id') != null){
             loggedInUserId = JSON.parse(localStorage.getItem('fusion:u_id'))
           }
        }catch(e){console.log(e)}
        this.connectToWebSocket({websocketurl:`wss://${tempNotifierIP}/dam_websocket`, loggedInUserId: loggedInUserId}).then(()=>{
           console.log("[Websocket][Connected] from inside plugin iframe framework");
        });
      },
      registerOnlyVuexStores(e){
        console.log("[registerOnlyVuexStores]",e);
        if(e.pluginStore && Array.isArray(e.pluginStore) && e.pluginStore.length){
            for(let i = 0; i < e.pluginStore.length; i++){
              if(!this.$store.hasModule(e.pluginStore[i].module))
                this.$store.registerModule(e.pluginStore[i].module,e.pluginStore[i].store); // registers store dynamically at run time
            }
        }else{
          if(e.pluginStore && !this.$store.hasModule(e.pluginStore.module))
              this.$store.registerModule(e.pluginStore.module,e.pluginStore.store); // registers store dynamically at run time
        }
      },
      registerStoreAndRoutes(e){
        /**
         *   This implementation is done for Media Pipeline and PAM to solve the issue of using other components(external plugin) into it.
         *   To check the example please look into `Media Pipeline` and PAM
         */
        console.log("[registerDampluginsRoutes]",e);
        if(e.pluginStore && Array.isArray(e.pluginStore) && e.pluginStore.length){
              for(let i = 0; i < e.pluginStore.length; i++){
                if(!this.$store.hasModule(e.pluginStore[i].module))
                  this.$store.registerModule(e.pluginStore[i].module,e.pluginStore[i].store); // registers store dynamically at run time
              }
          }else{
            if(e.pluginStore && !this.$store.hasModule(e.pluginStore.module))
                this.$store.registerModule(e.pluginStore.module,e.pluginStore.store); // registers store dynamically at run time
          }
  
         if(e && e.routes && Array.isArray(e.routes)){
            for(let i = 0; i < e.routes.length;i++){
                for(let j = 0; j < e.routes[i].routes.length;j++){
                    this.$router.addRoute(e.routes[i].parentRouteName,e.routes[i].routes[j]);
                }
            }
         }
         if(e && e.childRoutes && Array.isArray(e.childRoutes) && e.childRoutes.length){
            for(let j = 0; j < e.childRoutes.length;j++){
                this.$router.addRoute(e.childRoutes[j].parentRouteName,e.childRoutes[j].route);
            }
         }
      },
      isEnabled(priv){
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
      },

      loadPluginsWithinIframe(){
        const pluginName = String(window.name).toLowerCase();
        this.getUserInfoFromServer({params:{userId:JSON.parse(localStorage.getItem('fusion:u_id'))}}).then(() => {
          this.getStartUpDataFromServer().then((startupDataInfo)=>{
             try{
                this.connectToFusionWebSocket(startupDataInfo);
             }catch(e){console.log(e)}
            this.updateAllUserActionstoInMem().then(()=>{
              this.getInstalledPluginsFromServer().then((data) => {
                 let plugin = data.plugins.find((e)=> String(e.plugin_name).toLowerCase() == pluginName);
                 console.log("pluginWindowName",plugin);
                 try {
                      let isAnyPrivEnabled = false;
                      if('privileges' in plugin){
                        for(let a of plugin.privileges){
                          if(this.isEnabled(a)){
                            isAnyPrivEnabled = true;
                            break;
                          }
                        }
                      }
                      if(this.isEnabled(plugin.privilege_id) || isAnyPrivEnabled){
                        plugin["id"] = plugin["plugin_id"]
                      }
                      console.log("plugin ................>",plugin);
                      this.registerDamPlugin({
                        plugin: plugin,       // eslint-disable-line no-undef
                        jsFileUrl:`${window.location.origin}/damplugins${plugin.web_hook_path}` ,
                        damInterface: { actionRegistrator: this.registerAction || (() => {}), updateRegisteredAction: this.updateAction || (() => {}), quickAccessPanelRegistrator: this.registerExternalPluginToQuickAccessPanel || (() => {}), createReviewButtonRegsitrator: this.registerCreateReviewButton || (() => {}), overflowMenuRegistrator: this.registerExternalPluginToOverflowMenu || (() => {}), systemSettingsMenuRegistrator: this.registerExternalPluginToSystemSettingsMenu || (() => {}), settingsSideMenuRegistrator: this.registerSettingsSideNavMenu || (() => {}), propertiesTopNavBarRegistrator: this.registerPropertiesTopNavigationBar || (() => {}), mediaBrowseIconRegistrator: this.registerMediaBrowseIconToOpenDialog || (() => {}), importExportMenuRegistrator: this.registerExternalPluginToImportExportSettingsMenu || (() => {}), shareMenusRegistrator: this.registerShareNavMenus || (() => {}), reportsSideMenuRegistrator: this.registerReportsSideNavMenu || (() => {}), setPluginDefaultData: this.registerPluginDefaultData || (() => {}), dashboardWidgetsRegistrator: this.registerDashboardWidgetsData || (() => {}), globalNewButtonRegistrator: this.registerGlobalButtonExternalPlugins || (() => {}), propertiesMetadataRegistrator: this.registerPropertiesMetadata || (() => {}), metadataDockListRegistrator: this.registerMetadataDock || (() => {}), reviewTagsArrRegistrator: this.registerAllReviewTags || (() => {}), subclipRegistrator: this.registerSubclipPlugin || (() => {}), registerPropertiesTabPlugins: this.registerPropertiesTabsPlugins || (() => {}), registerDashboardWidgetsPlugins: this.registerDashboardPluginWidgets || (() => {}), pamBrowsersPluginsRegistrator: this.registerPamBrowserPlugin || (() => {}), myAppRegistrator: this.registerMyApp || (() => {}), },
                        callbackFun:(res)=>{
                            try{
                               if(res.iframePluginInfo && res.iframePluginInfo.routeInfo.name){
                                  let resolvedR = this.$router.resolve({name:res.iframePluginInfo.routeInfo.name});
                                  if(resolvedR.resolved.matched.length){
                                    this.$router.replace({name:res.iframePluginInfo.routeInfo.name});
                                    if(Object.prototype.hasOwnProperty.call(this,'selectedRouteName')){
                                        this.selectedRouteName = res.iframePluginInfo.routeInfo.name;
                                    }else{
                                        if(this.$root.$children.length){
                                          if(Object.prototype.hasOwnProperty.call(this.$root.$children[0],'selectedRouteName'))
                                            this.$root.$children[0].selectedRouteName = res.iframePluginInfo.routeInfo.name;
                                        }
                                    }
                                    return;
                                  }
                               }
                            }catch(e){console.log(e)}
                            if(res && Object.prototype.hasOwnProperty.call(res,'iframePluginInfo') && res.iframePluginInfo){
                                Utils.loadCssBundle({id:res.iframePluginInfo.css.id,cssUrl:res.iframePluginInfo.css.cssUrl});
                                Utils.loadPluginBundles([{id:res.iframePluginInfo.js.id,jsUrl:res.iframePluginInfo.js.jsUrl}],res.iframePluginInfo.js.eventName).then(async(e)=>{
                                  console.log("E.............",e[0]);
                                  this.registerOnlyVuexStores(e[0]);
                                  console.log("res.iframePluginInfo.routeInfo.parent",res.iframePluginInfo.routeInfo.parent);
                                  console.log("res.iframePluginInfo.routeInfo.route res.iframePluginInfo.routeInfo.route",res.iframePluginInfo.routeInfo.route);
                                  res.iframePluginInfo.routeInfo.route[2][res.iframePluginInfo.routeInfo.name] = e[0].iframeEntryComponent;
                                  if(!res.iframePluginInfo.routeInfo.parent){
                                     this.$router.addRoute(new Route(...res.iframePluginInfo.routeInfo.route));
                                  }else{
                                    this.$router.addRoute(res.iframePluginInfo.routeInfo.parent,new Route(...res.iframePluginInfo.routeInfo.route));
                                  }
                                  this.$router.replace({name:res.iframePluginInfo.routeInfo.name});
                                  if(Object.prototype.hasOwnProperty.call(this,'selectedRouteName')){
                                      this.selectedRouteName = res.iframePluginInfo.routeInfo.name;
                                  }else{
                                      if(this.$root.$children.length){
                                        if(Object.prototype.hasOwnProperty.call(this.$root.$children[0],'selectedRouteName'))
                                           this.$root.$children[0].selectedRouteName = res.iframePluginInfo.routeInfo.name;
                                      }
                                  }
                                });
                            }
                        }
                     });
                 }catch(e){console.log(e)}
              });
              //this.registorInstalledPlugins(true);
            });
          });
        });
      },
    },
  computed:{
      ...mapGetters("users", ["getLoggedInUserPrivilege"]),
  },
}